import { Component } from "react";
import { decode as base64_decode } from "base-64";

import { observer } from "mobx-react";
import withRouter from "../withRouter";
import { StoreContext } from "../store/RootStore";
import { Image, Typography } from "antd";
import Cookies from "universal-cookie";
import conf from "../config";
import { Helmet } from "react-helmet";
import drive7Icon from "../../src/assets/images/drive7.ico";
import awtlIcon from "../../src/assets/images/awtl.ico";
import starlingIcon from "../../src/assets/images/starling.ico";
import secureIcon from '../../src/assets/images/secure.ico';
const { Title } = Typography;
class DistributorCertificate extends Component {
  constructor(props) {
    super(props);
    this.cookies = new Cookies();
    // this.mapShow = Number(
    //   JSON.parse(JSON.stringifythis.cookies.get("mapShow"))
    // );
    this.state = {
      name: ''
    };
    this.showLaunchingItems = {
      livetracking: false,
      dashboard: false,
      historytracking: false,
      detailtracking: false,
      parentalertreportlist: false,
      master: false,
      AdvanceDashboard: false,
      vehiclelist: false,
      parentreport: false,
      maintenancedashboard: false,
      showHelpModal: false,
      showLaunchingDashboard: 2,
    };
    // console.log(this.mapShow);


  }

  componentDidMount() {
    const data = JSON.parse(base64_decode(this.cookies.get("data")));
    this.setState({ name: data.userName });
    // this.updateDashboard(1);
  }

  updateIcons = () => {
    if (conf.project === "drive7") {
      return {
        favicon: drive7Icon,
        appleTouchIcon: drive7Icon,
      };
    } else if (conf.project === "awtltrack") {
      return {
        favicon: awtlIcon,
        appleTouchIcon: awtlIcon,
      };
    } else if (conf.project === "starlingeye") {
      return {
        favicon: starlingIcon,
        appleTouchIcon: starlingIcon,
      };
    } else if (conf.project === "trackeazy") {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    } else if (conf.project === "securetrack") {
      return {
        favicon: secureIcon,
        appleTouchIcon: secureIcon,
      };
    } else {
      return {
        favicon: "/favicon.ico",
        appleTouchIcon: "/favicon.ico",
      };
    }
  };

  updateTitle = () => {
    if (conf.project === "drive7") {
      return "Drive7";
    } else if (conf.project === "awtltrack") {
      return "AWTL";
    } else if (conf.project === "starlingeye") {
      return "Starlingeye";
    } else if (conf.project === "trackeazy") {
      return "Trackeazy";
    } else if (conf.project === "securetrack") {
      return "SecureTrack";
    } else {
      return "Trackeazy";
    }
  };

  render() {
    const { favicon, appleTouchIcon } = this.updateIcons();

    return (
      <>
        <Helmet>
          <title>{this.updateTitle()}</title>
          <link rel="icon" href={favicon} />
          <link rel="apple-touch-icon" href={appleTouchIcon} />
        </Helmet>


        <div className="distcerapp-container">
          <div className="login-overlay">


            {/* Logo Section */}
            <div className="container mt-4 d-flex">
              <div className="w-100">
                <i
                  class="bi bi-arrow-left-circle"
                  style={{
                    color: "white",
                    fontSize: "25px",
                    marginInlineStart: "25px",
                  }}
                  onClick={async () => {
                    this.props.navigate("/DistributorOptionsMain")
                  }}
                ></i>
              </div>
              <div className="headtitle w-100" style={{ textAlign: 'center' }}>
                <Title style={{ marginTop: '10%', color: 'white', fontSize: '50px' }}>
                  {this.context.translate('_CERTIFICATE1_')}
                </Title>
              </div>
              <div className="w-100 d-flex text-end">
                <Image
                  src={require('../assets/images/swd-dashboard-st.png')}
                  alt="SecureTrackX"
                  preview={false}
                  className="certiLogo"
                />
              </div>
            </div>
            <Title level={5} className="white-text distributor-title" style={{ marginBottom: '5px', color: 'white' }}>
              {this.state.name}
            </Title>


            {/* Login Circles */}
            <div className="distlogin-section">
              {/* SecurePath Circle */}
              <div className="d-flex gap-15 certi-1">
                <div className="distmaincircle login-circle"
                  onClick={() => this.props.navigate("/CertificateSchoolBus")}
                  style={{ cursor: "pointer" }}>
                  <div className="certibgschool text-center">
                    <div className="back-overlay">
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        {this.context.translate('_SCHOOL_BUS1_')}

                      </Title>
                    </div>
                  </div>
                </div>

                <div className="distmaincircle login-circle"
                  onClick={() => this.props.navigate("/CertificateOtherCategories")}
                  style={{ cursor: "pointer" }}>
                  <div className="certibgcat text-center">
                    <div className="back-overlay">
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        {this.context.translate('_OTHER_CATEGORIES_')}

                      </Title>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex gap-15 certi-2">

                <div className="distmaincircle login-circle "
                  onClick={() => this.props.navigate("/CertificateDesertSafari")}
                  style={{ cursor: "pointer" }}>
                  <div className="certibgdesert text-center">
                    <div className="back-overlay">
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        {this.context.translate('_DESERT_SAFARI_')}
                      </Title>
                    </div>
                  </div>
                </div>

                <div className="distmaincircle login-circle"
                  onClick={() => this.props.navigate("/CertificateRentACar")}
                  style={{ cursor: "pointer" }}>
                  <div className="certibgrent text-center">
                    <div className="back-overlay">
                      <Title level={5} className="white-text" style={{ marginBottom: '5px', color: 'white' }}>
                        {this.context.translate('_RENT_A_CAR_')}


                      </Title>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}
DistributorCertificate.contextType = StoreContext;
export default observer(withRouter(DistributorCertificate));
